import { render, staticRenderFns } from "./NewGlobalVariable.vue?vue&type=template&id=36bb01b8&scoped=true"
import script from "./NewGlobalVariable.vue?vue&type=script&lang=js"
export * from "./NewGlobalVariable.vue?vue&type=script&lang=js"
import style0 from "./NewGlobalVariable.vue?vue&type=style&index=0&id=36bb01b8&prod&lang=scss"
import style1 from "./NewGlobalVariable.vue?vue&type=style&index=1&id=36bb01b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb01b8",
  null
  
)

export default component.exports